/** Inline SVG icons. Small enough that a library isn't worth the bytes. */

export function SearchIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="rgba(242, 238, 231, 0.45)" strokeWidth="1.5" aria-hidden="true">
      <circle cx="7" cy="7" r="4.6" />
      <path d="M10.6 10.6 L14 14" strokeLinecap="round" />
    </svg>
  );
}

/** Open eye when figures are showing, struck through when they're masked. */
export function EyeIcon({ off }: { off?: boolean }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M1.2 8S3.7 3.6 8 3.6 14.8 8 14.8 8 12.3 12.4 8 12.4 1.2 8 1.2 8Z" />
      <circle cx="8" cy="8" r="2.1" />
      {off ? <path d="M2.6 13.4 13.4 2.6" /> : null}
    </svg>
  );
}

export type TabName =
  | 'budgets'
  | 'overview'
  | 'accounts'
  | 'transactions'
  | 'analytics'
  | 'advisor'
  | 'investments'
  | 'settings';

const PATHS: Record<TabName, React.ReactNode> = {
  budgets: <><rect x="3" y="4" width="18" height="16" rx="3" /><path d="M3 10h18M9 10v10M15 10v10" /></>,
  overview: (
    <>
      <rect x="3" y="3" width="7" height="8" rx="1.6" />
      <rect x="14" y="3" width="7" height="5" rx="1.6" />
      <rect x="3" y="15" width="7" height="6" rx="1.6" />
      <rect x="14" y="12" width="7" height="9" rx="1.6" />
    </>
  ),
  accounts: (
    <>
      <rect x="3" y="6" width="18" height="13" rx="2.2" />
      <path d="M3 10h18" strokeLinecap="round" />
      <path d="M7 15h3" strokeLinecap="round" />
    </>
  ),
  transactions: (
    <>
      <path d="M4 7h16" strokeLinecap="round" />
      <path d="M4 12h16" strokeLinecap="round" />
      <path d="M4 17h10" strokeLinecap="round" />
    </>
  ),
  analytics: (
    <>
      <path d="M4 19V9" strokeLinecap="round" />
      <path d="M10 19V5" strokeLinecap="round" />
      <path d="M16 19v-7" strokeLinecap="round" />
      <path d="M21 19H3" strokeLinecap="round" />
    </>
  ),
  advisor: (
    <>
      <path d="M20 12a8 8 0 1 0-3.2 6.4L20 20l-1.2-3.4A7.9 7.9 0 0 0 20 12Z" strokeLinejoin="round" />
      <circle cx="9" cy="12" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="12.5" cy="12" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="16" cy="12" r="0.9" fill="currentColor" stroke="none" />
    </>
  ),
  investments: (
    <>
      <path d="M4 16l4.5-5 3.5 3.5L20 7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 7h5v5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path
        d="M12 2.5v2M12 19.5v2M21.5 12h-2M4.5 12h-2M18.7 5.3l-1.4 1.4M6.7 17.3l-1.4 1.4M18.7 18.7l-1.4-1.4M6.7 6.7 5.3 5.3"
        strokeLinecap="round"
      />
    </>
  ),
};

export function TabIcon({ name, className }: { name: TabName; className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}

export function ArrowUpRight() {
  return (
    <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M3 9L9 3" strokeLinecap="round" />
      <path d="M4 3h5v5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
